import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { LOGIN_TYPE_ADMIN,CLIENT_LIST_ROUTE, LOGIN_TYPE_USER, SERVICE14_TEXT, SERVICE13_TEXT,SERVICE18_TEXT,SERVICE19_TEXT,SERVICE20_TEXT,SERVICE21_TEXT,SERVICE28_TEXT,SERVICE29_TEXT,
    SERVICE30_TEXT, SERVICE31_TEXT,SERVICE32_TEXT,SERVICE36_TEXT, SERVICE10_TEXT, SERVICE37_TEXT,SERVICE38_TEXT, SERVICE40_TEXT, SERVICE41_TEXT, SERVICE42_TEXT} from "../helper/Constants";
import { reactLocalStorage } from "reactjs-localstorage";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            login_type: "client",
            user_name: "",
            urlForIcon:'',
            navArray:[],
            adminLoginObj: {}
        }
    }
    
    componentDidMount() {
        if (reactLocalStorage.get("login_type") === LOGIN_TYPE_USER) {
            this.setState({urlForIcon:`${"/admin/client-edit-view/"+reactLocalStorage.get("login_user_id")}`});

            //bbUser Nav array setTimeout is using for get value
            this.renderNavigation();
            setTimeout(()=>{
                this.renderNavigation();
            },2000);
        }
      
        if (reactLocalStorage.get("login_type") === LOGIN_TYPE_ADMIN) {
            this.setState({urlForIcon:`${"/admin/dashboard"}`});
        }
        //console.log('aa',window.location.pathname);
        this.setState({
            login_type: reactLocalStorage.get("login_type"),
            user_name: reactLocalStorage.get("user_name"),
        });
        if(reactLocalStorage.get('adminLoginObj') !== undefined) {
            this.setState({
                adminLoginObj: JSON.parse(reactLocalStorage.get('adminLoginObj'))
            })
        }
    }

    renderNavigation = () => {
        let navArray = [];
        if (reactLocalStorage.get("is_have_primePDF_service") === SERVICE13_TEXT) {
            navArray.push({path:'/admin/rcprime',label:'RCPrime PDF'});
        }
        if (reactLocalStorage.get("is_have_rcExcel_service") === SERVICE10_TEXT) {
            navArray.push({path:"/admin/rc-bulk-upload",label:"Bulk RC Upload"});
        }
        if (reactLocalStorage.get("is_have_challanExcel_service") === SERVICE37_TEXT) {
            navArray.push({path:"/admin/challan-bulk-upload",label:"Bulk CHALLAN Upload"});
        }
        if (reactLocalStorage.get("is_have_api_panFetchpdf_service") === SERVICE28_TEXT) {
            navArray.push({path:"/admin/PanFetchPdf",label:"Pan Fetch PDF"});
        }
        if (reactLocalStorage.get("is_have_api_panExtensivepdf_service") === SERVICE29_TEXT) {
            navArray.push({path:"/admin/PanExtensivePdf",label:"Pan Extensive PDF"});
        }
        if (reactLocalStorage.get("is_have_api_aadhaarFetchpdf_service") === SERVICE36_TEXT) {
            navArray.push({path:"/admin/AadhaarFetchPdf",label:"Aadhaar Fetch PDF"});
        }
        if (reactLocalStorage.get("is_have_api_aadhaarExtractionpdf_service") === SERVICE30_TEXT) {
            navArray.push({path:"/admin/AadhaarExtractionPdf",label:"Aadhaar Extraction PDF"});
        }
        if (reactLocalStorage.get("is_have_api_basicForgerypdf_service") === SERVICE31_TEXT) {
            navArray.push({path:"/admin/BasicForgeryPdf",label:"Basic Forgery PDF"});
        }
        if (reactLocalStorage.get("is_have_api_advanceForgerypdf_service") === SERVICE32_TEXT) {
            navArray.push({path:"/admin/AdvanceForgeryPdf",label:"Advance Forgery PDF"});
        }
        if (reactLocalStorage.get("is_have_api_challanpdf_service") === SERVICE18_TEXT) {
            navArray.push({path:"/admin/challan",label:"Challan PDF"});
        }
        if (reactLocalStorage.get("is_have_rcPrimeReversePdf_service") === SERVICE21_TEXT) {
            navArray.push({path:"/admin/RCPrimeReversePdf",label:"RCPrime Reverse PDF"});
        }
        if (reactLocalStorage.get("is_have_api-history_service") === SERVICE14_TEXT) {
            navArray.push({path:"/admin/api-history",label:"Api History"});
        }
        if (reactLocalStorage.get("is_have_api_variant_mapping_service") === SERVICE20_TEXT) {
            navArray.push({path:"/admin/variant-mapping",label:"Variant Mapping"});
        }
        if (reactLocalStorage.get("is_have_mobile_rc_excel_service") === SERVICE38_TEXT) {
            navArray.push({path:"/admin/mobile-rc-bulk-upload",label:"Bulk Mobile RC Upload"});
        }
        if (reactLocalStorage.get("is_have_raw_report_service") === SERVICE40_TEXT) {
            navArray.push({path:"/admin/reports",label:"Raw Reports"});
        }
        if (reactLocalStorage.get("is_have_buheadbilling_service") === SERVICE41_TEXT) {
            navArray.push({path:"/admin/bu-head-billing-report",label:"BU Head Billing Reports"});
        }
        if (reactLocalStorage.get("is_have_dashboard_service") === SERVICE42_TEXT) {
            navArray.push({path:"/admin/dashboard",label:"Dashboard API Hit Counts"});
        }
        //
        //console.log('navArray',navArray);
        this.setState({
            navArray:navArray
        })
    }

    backToAdmin = () => {
        reactLocalStorage.clear();

        reactLocalStorage.set('authToken', this.state.adminLoginObj.authToken);
        reactLocalStorage.set("expires_at", this.state.adminLoginObj.expires_at); 
        reactLocalStorage.set("login_type", this.state.adminLoginObj.login_type);
        reactLocalStorage.set("user_name", this.state.adminLoginObj.user_name);
        reactLocalStorage.set("internalToken", this.state.adminLoginObj.internalToken);

        var url = window.location.href;
        var arr = url.split("/");
        url = arr[0] + "//" + arr[2] + "/" + arr[3] + CLIENT_LIST_ROUTE;
        //console.log('url',url);
        window.location.href = url;
    }

    render() {
        let settingSubActiveClass = '';
        if (window.location.pathname === '/admin/setting' || window.location.pathname === '/admin/api-history' || window.location.pathname === '/admin/fuel-transmission-list' || window.location.pathname === '/admin/master-services' || window.location.pathname === '/admin/audithistorylist' || window.location.pathname === '/admin/update-api-source-order') {
            settingSubActiveClass = 'active';
        }
        let subActiveClass = '';
        if (window.location.pathname === '/admin/rcprime' || window.location.pathname === '/admin/rc-bulk-upload' || window.location.pathname === '/admin/challan' || window.location.pathname === '/admin/RCPrimeReversePdf') {
            subActiveClass = 'active';
        }
        return (
            <header className="header">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-auto">
                            <div className="logo">
                                <NavLink to={this.state.urlForIcon} ><img src="/assets/images/logo.png" alt="" /></NavLink>
                            </div>
                        </div>
                        <div className="col">
                            {this.state.login_type === LOGIN_TYPE_ADMIN ?
                                <div className="mainNav">
                                    <ul>
                                        <li><NavLink to={"/admin/dashboard"} >Dashboard</NavLink></li>
                                        <li><a href={"/admin/client-list?loginStatus=login-active"} >Client List</a></li>
                                        <li className="more">
                                            <a className={settingSubActiveClass} href="#javascript">Setting</a>
                                            <ul className="subLink">
                                                <li><NavLink to={"/admin/fuel-transmission-list"} >Configuration</NavLink></li>
                                                <li><NavLink to={"/admin/setting"} >Setting</NavLink></li>
                                                <li><NavLink to={"/admin/master-services"} >Services Plan List</NavLink></li>
                                                <li><NavLink to={"/admin/audithistorylist"} >Audit History</NavLink></li>
                                                <li><NavLink to={"/admin/update-api-source-order"} >API Source Order</NavLink></li>
                                                <li><NavLink to={"/admin/source-list"} >Source List</NavLink></li>
                                            </ul>
                                        </li>
                                        <li><NavLink to={"/admin/reports"} >Reports</NavLink></li>
                                        <li className="more">
                                            <a className={subActiveClass} href="#javascript">Plans</a>
                                            <ul className="subLink">
                                                <li><NavLink to={"/admin/rcprime"} >RCPrime PDF</NavLink></li>
                                                <li><NavLink to={"/admin/rc-bulk-upload"} >Bulk RC Upload</NavLink></li>
                                                <li><NavLink to={"/admin/challan-bulk-upload"} >Bulk Challan Upload</NavLink></li>
                                                <li><NavLink to={"/admin/mobile-rc-bulk-upload"} >Bulk Mobile RC Upload</NavLink></li>
                                                <li><NavLink to={"/admin/challan"} >Challan PDF</NavLink></li>
                                                <li><NavLink to={"/admin/RCPrimeReversePdf"} >RCPrime Reverse PDF</NavLink></li>
                                                <li><NavLink to={"/admin/PanFetchPdf"} >Pan Fetch PDF</NavLink></li>
                                                <li><NavLink to={"/admin/PanExtensivePdf"} >Pan Extensive PDF</NavLink></li>
                                                <li><NavLink to={"/admin/AadhaarFetchPdf"} >Aadhaar Fetch PDF</NavLink></li>
                                                <li><NavLink to={"/admin/AadhaarExtractionPdf"} >Aadhaar Extraction PDF</NavLink></li>
                                                <li><NavLink to={"/admin/BasicForgeryPdf"} >Basic Forgery PDF</NavLink></li>
                                                <li><NavLink to={"/admin/AdvanceForgeryPdf"} >Advance Forgery PDF</NavLink></li>
                                                <li><NavLink to={"/admin/bu-head-billing-report"} >BU Head Billing Report</NavLink></li>
                                                <li><NavLink to={"/admin/api-history"} >Api History</NavLink></li>
                                                <li><NavLink to={"/admin/variant-mapping"} >Variant Mapping</NavLink></li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                                :
                                <div className="mainNav">
                                <ul>
                                    {(reactLocalStorage.get("is_have_primePDF_service") == SERVICE13_TEXT || reactLocalStorage.get("is_have_api-history_service") == SERVICE14_TEXT || reactLocalStorage.get("is_have_api_variant_mapping_service") == SERVICE20_TEXT || reactLocalStorage.get("is_have_rcPrimeReversePdf_service") == SERVICE21_TEXT ||
                                      reactLocalStorage.get("is_have_api_challanpdf_service") == SERVICE18_TEXT || reactLocalStorage.get("is_have_api_panFetchpdf_service") == SERVICE28_TEXT || reactLocalStorage.get("is_have_api_panExtensivepdf_service") == SERVICE29_TEXT || reactLocalStorage.get("is_have_api_aadhaarExtractionpdf_service") == SERVICE30_TEXT ||
                                      reactLocalStorage.get("is_have_api_basicForgerypdf_service") == SERVICE31_TEXT || reactLocalStorage.get("is_have_api_basicForgerypdf_service") == SERVICE32_TEXT || reactLocalStorage.get("is_have_api_aadhaarFetchpdf_service") == SERVICE36_TEXT || reactLocalStorage.get("is_have_rcExcel_service") == SERVICE10_TEXT ||
                                      reactLocalStorage.get("is_have_challanExcel_service") == SERVICE37_TEXT || reactLocalStorage.get("is_have_raw_report_service") === SERVICE40_TEXT || reactLocalStorage.get("is_have_buheadbilling_service") === SERVICE41_TEXT || reactLocalStorage.get("is_have_dashboard_service") === SERVICE42_TEXT) ?
                                     <>
                                     <li><NavLink to={`${"/admin/dashboard-client/"}`}>Dashboard</NavLink></li>
                                     <li><NavLink to={`${"/admin/client-edit-view/"+reactLocalStorage.get("login_user_id")}`} >My Profile</NavLink></li>
                                     </>
                                     :
                                    ''
                                    }
                                    {
                                        (this.state.navArray.length > 0) ? 
                                            <li className="more">
                                                <a className={subActiveClass} href="#javascript">Plans...</a>
                                                <ul className="subLink">
                                                {
                                                    this.state.navArray.map((item, i)=>{
                                                        return (<li key={i}><NavLink to={item.path} >{item.label}</NavLink></li>)
                                                    })
                                                }
                                                </ul>
                                            </li>
                                        :
                                        ""
                                    }
                                </ul>
                            </div>
                            }
                        </div>
                        <div className="col-auto">
                            <div className="headerRight">
                                <div className="welText">Welcome: <strong>{this.state.user_name}</strong></div>
                                <NavLink className="borderBtn" to={"/admin/logout"} exact activeClassName="active"> Logout </NavLink>
                                {
                                    (this.state.adminLoginObj.login_type === 'admin') ?
                                    <>
                                    &nbsp; <button className="borderBtn" title="Back to admin" onClick={this.backToAdmin}><i className="fa fa-undo"></i></button>
                                    </>
                                    :''
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
export default Header;
